<template>
  <!-- 添加问题弹窗 -->
  <el-dialog title="" :visible.sync="visible" class="add-question-dialog-components" :close-on-click-modal="false" :before-close="close" :show-close="true" width="500px">
    <div slot="title" class="title">添加问题</div>
    <div class="content">
      <div class="padding-b-20">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="预设问题" prop="title">
            <el-input style="width: 300px" size="small" maxlength="16" v-model="ruleForm.title" placeholder="请输入问题（16字内），ex，主队能获胜吗？ "></el-input>
          </el-form-item>
          <el-form-item label="A选项" prop="item1">
            <el-input style="width: 300px" size="small" maxlength="8" v-model="ruleForm.item1" placeholder="A选项（8字内）ex，能"></el-input>
          </el-form-item>
          <el-form-item label="B选项" prop="item2">
            <el-input style="width: 300px" size="small" maxlength="8" v-model="ruleForm.item2" placeholder="B选项（8字内）ex，不能"></el-input>
          </el-form-item>
          <el-form-item label="关联直播">
            <el-input style="width: 300px" size="small" placeholder="" :value="match.comp + ' ' + match.match_title" disabled></el-input>
          </el-form-item>
          <el-form-item label="最小投注额" prop="min_bet">
            <el-select style="width: 300px" size="small" filterable v-model="ruleForm.min_bet" placeholder="请选择">
              <el-option :label="item.amount" v-for="(item, index) in moneyList" :value="item.amount" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="flex-middle">
          <div class="content-btn flex-middle" @click="commit">确定</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { dayCount } from "@/util/time";
import { mapState, mapMutations } from "vuex";
import { post } from "../../util/http";
export default {
  computed: {
    ...mapState(["userInfo", "appConfig", "chips"]),
    moneyList() {
      return [...this.chips];
    },
  },

  data() {
    return {
      date: "",
      visible: false,
      match: {},
      ruleForm: {
        title: "",
        item1: "",
        item2: "",
        match_id: 0,
        min_bet: "",
      },
      rules: {
        title: [{ required: true, message: "请输入问题", trigger: "change" }],
        item1: [{ required: true, message: "请输入A选项", trigger: "change" }],
        item2: [{ required: true, message: "请输入B选项", trigger: "change" }],
        match_id: [{ required: true, message: "请选择直播", trigger: "change" }],
        min_bet: [{ required: true, message: "请输入最小投注", trigger: "change" }],
      },
    };
  },
  created() {
    this.date = dayCount(0);
  },
  destroyed() {},
  methods: {
    open(item = null) {
      this.date = dayCount(0);
      this.visible = true;
      if (item) {
        console.log(item);
        this.ruleForm = {
          title: item?.title || "",
          item1: item?.contentArr[0] || "",
          item2: item?.contentArr[1] || "",
          match_id: item.match_id,
          min_bet: item.min_bet / 100,
        };
        this.match = {
          match_title: item.match_title || "",
          comp: item.comp || "",
        };
      }
    },
    close() {
      this.$refs.ruleForm.resetFields();
      this.match = {};
      this.pendingMatch = [];
      this.visible = false;
    },
    commit() {
      this.$refs["ruleForm"].validate((valid) => {
        // console.log("this.ruleForm : ",this.ruleForm);
        if (valid) {
          let data = {
            content: `${this.ruleForm["item1"]}|${this.ruleForm["item2"]} `,
            item_num: 2,
            match_id: this.ruleForm["match_id"],
            match_title: this.match.match_title,
            comp: this.match.comp,
            min_bet: this.ruleForm["min_bet"] * 100,
            title: this.ruleForm["title"],
          };
          // console.log("data: ",data)
          post({
            url: "/api/guess/createQuestion",
            data,
          })
            .then(({ data: { data, status = "" } }) => {
              // console.log("data: ",data);
              if (status == 0) {
                this.$message({
                  message: "创建成功",
                  type: "success",
                  customClass: "ly-success",
                });
                this.$emit("refresh");
              } else {
                this.$message({
                  message: "创建失败",
                  type: "error",
                  customClass: "ly-error",
                });
              }
              this.close();
            })
            .catch((err) => {
              this.close();
              this.$message({
                message: "创建失败",
                type: "error",
                customClass: "ly-error",
              });
              console.warn("createQuestion err: ", err);
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus">
.add-question-dialog-components{
  z-index:1;
  border-radius: 8px;
.title{
	color : #333333;
	font-size : .16rem;
}
  .content{

    .content-btn{
		background: linear-gradient(90deg, #29F19C 0%, #02A1F9 100%);
		border-radius: 5px;
		width : 1.3rem;
		height : 35px;
		color : #ffffff;
		margin : .1rem;
		cursor: pointer;
	}
  }

  .dialog-footer_one>div{
    height: 40px;
    background: #26D99D;
    border-radius: 20px;
	margin: .2rem;
  }

.content-tip{
	color : #3C9CFE;
	margin : .3rem 0rem;
	font-size : .1rem;
}
/deep/{
	@import "../../assets/common-dialog-1.css";
	.el-form-item{
		margin-bottom : 10px;
	}
	.el-input--small .el-input__icon{
		line-height : 40px;
	}
}

}
</style>
